'use strict';

const cleanUpUrlAfterRedirect = regex => {
  const newUrl = window.location.href.split(regex)[0];
  if (window.history.pushState) {
    window.history.pushState(null, null, newUrl);
  } else {
    document.location.href = newUrl;
  }
};

module.exports = cleanUpUrlAfterRedirect;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/clean_up_url_after_redirect.js